import { Component, OnInit } from '@angular/core';
import { CurrencyRateService } from './currency-rate-service';
import { CurrencyRatesComponent } from './currency-rates';
import {Observable} from 'rxjs';

@Component({
    selector: 'dk-currency-rates-mobile-bar',
    template: require('./currency-rates-mobile-bar.html'),
    providers: [ CurrencyRateService ]
})

export class CurrencyRatesMobileBarComponent implements OnInit {
    rates: any[];
    errorMessage: string;
    loaded: boolean = false;
    currentPosition: number = 0;
    seconds: number;

    constructor(
        private currencyRateService: CurrencyRateService
    ) {
    }

    ngOnInit() {
        this.getCurrencyRates();
    }

    getCurrencyRates() {
        if (CurrencyRateService.currentRates) {
            this.rates = CurrencyRateService.currentRates;
        }

        this.currencyRateService.getCurrencyRatesSubject()
            .subscribe(
                rates => {
                    if (rates) {
                        if ((typeof rates === 'number')) {
                            this.seconds = rates;
                        } else {
                            this.rates = rates;
                            this.seconds = CurrencyRateService.refreshTime;
                        }
                        this.loaded = true;
                    }
                },
                error =>  this.errorMessage = <any>error);
    }

    moveLeft() {
        this.currentPosition = (this.currentPosition + this.rates.length - 1) % this.rates.length;
    }

    moveRight() {
        this.currentPosition = (this.currentPosition + this.rates.length + 1) % this.rates.length;
    }

    get rate(): boolean {
        return this.rates[this.currentPosition];
    }
}